import React from "react";
import DynamicFormField from "../../UI/DynamicFormField";
import s from "../Address.less";
import { addressFields } from "../helper";
import clsx from "clsx";
import GeoField from "../GeoField";
import { useTranslation } from "react-i18next";

const MainAddress = ({ isRu, dealerCoordinats, allDisabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={s.wrapperBase}>
        <div className={s.title}>Фактический адрес</div>
        <DynamicFormField
          name="mainAddressreestrAddress"
          label={t("dealers.reestrAddress")}
          type="text"
          className={s.mainAddress}
          disabled={true || allDisabled}
        />
        <DynamicFormField
          name="mainAddressfullAddress"
          label={t("dealers.fullAddress")}
          type="text"
          className={s.mainAddress}
          disabled={true || allDisabled}
        />
        {Object.entries(addressFields).map(([field, settings]) => (
          <div
            key={`mainAddress${field}`}
            className={clsx(s.item, {
              [s.itemWidth]: field === "address",
            })}
          >
            <GeoField
              prefix="mainAddress"
              field={field}
              isRu={isRu}
              allDisabled={allDisabled}
              {...settings}
            />
          </div>
        ))}
        <DynamicFormField
          name="mainAddressoffice"
          label={t("dealers.office")}
          type="text"
          className={clsx(s.item)}
          disabled={allDisabled}
        />
        <DynamicFormField
          name="mainAddressindex"
          label={t("dealers.index")}
          type="text"
          className={clsx(s.item)}
          disabled={true || allDisabled}
        />
      </div>
      <div className={s.coordinats}>
        <div className={s.title}>Географические координаты:</div>
        <div className={s.coordinatsWrapper}>
          {dealerCoordinats.map((field) => (
            <div key={field.name} className={clsx(s.itemCor)}>
              <DynamicFormField {...field} disabled={allDisabled} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default React.memo(MainAddress);
